export const surveyUploadSteps = {
  ExteriorOptional: 6,
  MainDisconnectSizeStep: 9,
  AdditionalItems: 14,
  AtticAccessInformation: 15,
  AtticPhotos: 19,
  AnythingElse: 20,
  DeckingDetails: 23,
  DeckingVerification: 24,
  DeckingVerificationPhotos: 25,
};

/*
 * Due to site survey not having a consistent numbering in steps and
 * backend following a totally different sequence this mapping is required
 */
export const surveyMap = {
  '0-0': 1,
  // Exterior
  '1-1': 2,
  '1-2': 3,
  '1-3': 4,
  '1-4': 5,
  '1-5': surveyUploadSteps.ExteriorOptional,
  // Exterior
  // System
  '2-1': 7,
  '2-2': 8,
  '2-3': surveyUploadSteps.MainDisconnectSizeStep,
  '2-4': 10,
  '2-5': 11,
  '2-6': 12,
  '2-7': 13,
  '2-8': surveyUploadSteps.AdditionalItems,
  // System
  // Attic
  '3-1': surveyUploadSteps.AtticAccessInformation,
  '3-2': 16,
  '3-3': 17,
  '3-4': 18,
  '3-5': surveyUploadSteps.AtticPhotos,
  // Attic
  // Roof Decking
  '4-1': 22,
  '4-2': surveyUploadSteps.DeckingDetails,
  '4-3': surveyUploadSteps.DeckingVerification,
  '4-4': surveyUploadSteps.DeckingVerificationPhotos,
  // Roof Decking
  // Anything Else
  '5-1': surveyUploadSteps.AnythingElse,
  // Anything Else
  // Submit
  '6-1': 21,
  // Submit
};

export const subStepName = {
  1: 'Welcome-to-the-Guided-Site-Survey',
  2: 'Front-of-the-House',
  3: 'Back-or-Side-of-the-House-1',
  4: 'Back-or-Side-of-the-House-2',
  5: 'Back-or-Side-of-the-House-3',
  6: 'Back-or-Side-of-the-House-Optional',
  7: 'Utility-Meter-Close-Up',
  8: 'Utility-Meter-Area',
  9: 'Main-Service-Disconnect-Size',
  10: 'Main-Service-Disconnect-Close-Up',
  11: 'Circuit-Breakers',
  12: 'Main-Electrical-Panel-Label',
  13: 'Main-Electrical-Panel-Area',
  14: 'Additional-Electrical-Items-Optional',
  15: 'Attic-Access-Information',
  16: 'Attic-Access-Location',
  17: 'Rafter-Spacing',
  18: 'Rafter-Depth',
  19: '360-Attic-Photos',
  20: 'Anything-Else',
  21: 'Submit',
  22: 'Roof-Decking',
  23: 'Roof-Decking-Verification',
  25: 'Roof-Decking-Photos',
};

export const findSurveyStep = (step: number, subStep: number): number | undefined => {
  const key = `${step}-${subStep}`;

  return surveyMap[key];
};

export function isMulteFileStep(step: number): boolean {
  return (
    step === surveyUploadSteps.ExteriorOptional ||
    step === surveyUploadSteps.AdditionalItems ||
    step === surveyUploadSteps.AtticPhotos ||
    step === surveyUploadSteps.DeckingVerificationPhotos
  );
}

export const getValueForSection = (stepSubStep: string, surveyStep) => {
  const [step, subStep] = stepSubStep.split('-');

  const sectionName = {
    0: 'Welcome',
    1: 'Exterior',
    2: 'System',
    3: 'Attic',
    4: 'RoofDecking',
    5: 'AnythingElse',
    6: 'Submit',
  };

  return `${sectionName[step]}-${subStep}-${subStepName[surveyStep]}`;
};

export const findSurveyStepKey = (surveyStep: number): string | undefined => {
  const key = Object.keys(surveyMap).find(k => surveyMap[k] === surveyStep);

  return key && getValueForSection(key, surveyStep);
};
